import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CountdownTimer } from './CountdownTimer';
export function CountdownUrgency() {
  return <section className="w-full px-5 py-16 sm:py-20 border-y" style={{
    backgroundColor: '#1A0000',
    borderColor: 'rgba(255,59,48,0.3)'
  }} data-id="element-57">
      <div className="mx-auto max-w-3xl text-center" data-id="element-58">
        <Reveal data-id="element-59">
          <p className="flex items-center justify-center gap-2 text-sm sm:text-base font-bold uppercase tracking-wide" style={{
          color: '#FF3B30'
        }} data-id="element-60">
            <ClockIcon className="w-5 h-5" aria-hidden="true" data-id="element-61" />
            El precio de lanzamiento termina en:
          </p>
        </Reveal>

        <div className="mt-8" data-id="element-62">
          <CountdownTimer data-id="element-63" />
        </div>

        <div className="mt-10" data-id="element-64">
          <div className="flex items-center justify-between text-sm mb-2" data-id="element-65">
            <span className="font-semibold" style={{
            color: '#FF3B30'
          }} data-id="element-66">
              🔴 68% de los cupos tomados
            </span>
          </div>
          <div className="h-3 w-full rounded-full overflow-hidden bg-white/10" data-id="element-67">
            <motion.div className="h-full rounded-full" style={{
            backgroundColor: '#FF3B30'
          }} initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1,
            ease: 'easeOut'
          }} data-id="element-68" />
          </div>
        </div>

        <p className="mt-6 text-sm text-white/70" data-id="element-69">
          Después sube y no vuelve al precio de lanzamiento.
        </p>
      </div>
    </section>;
}